import styled, { css } from 'styled-components';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';
import { Typo } from 'src/components/common/ui';
import { cpdsMediaQueryVals } from 'src/components/common/cpds/token/shared/common';
import { Cpds } from '@Cpds.Ui';

const fontClass = {
  '6_COLUMNS': 'cpds-display-roman-book-03',
  '6_COLUMNS_PILL': 'cpds-heading-roman-book-06',
  '4_COLUMNS': 'cpds-heading-roman-book-06',
  '3_COLUMNS': 'cpds-heading-roman-book-06',
  FULL_WIDTH: 'cpds-heading-roman-book-06',
  HOTEL_CARD_3_COLUMNS: 'cpds-body-roman-medium-07',
  HOTEL_CARD_4_COLUMNS: 'cpds-body-roman-medium-07',
  HOTEL_CARD_6_COLUMNS: 'cpds-display-roman-book-03',
  HOTEL_CARD_HORIZONTAL_PRODUCT_FIXTURE: 'cpds-body-roman-medium-08',
  PORMOTION_CARD_3_COLUMNS: 'cpds-heading-roman-book-06',
  PORMOTION_CARD_4_COLUMNS: 'cpds-heading-roman-book-06',
  PORMOTION_CARD_6_COLUMNS: 'cpds-display-roman-book-03',
  VERTICAL_OVERLAY_3_COLUMNS_DESKTOP: 'cpds-heading-roman-book-06',
  VERTICAL_OVERLAY_4_COLUMNS_DESKTOP: 'cpds-heading-roman-book-06',
  VERTICAL_OVERLAY_6_COLUMNS_DESKTOP: 'cpds-display-roman-book-03',
  VERTICAL_OVERLAY_3_COLUMNS_MOBILE: 'cpds-heading-roman-book-06',
  VERTICAL_OVERLAY_4_COLUMNS_MOBILE: 'cpds-heading-roman-book-06',
  VERTICAL_OVERLAY_6_COLUMNS_MOBILE: 'cpds-heading-roman-book-06',
  HORIZONTAL_OVERLAY_DEFAULT_DESKTOP: 'cpds-heading-roman-med-05',
  HORIZONTAL_OVERLAY_HOVER_DESKTOP: 'cpds-body-roman-medium-07',
  BREAKER_COLLAGE_CARD: 'cpds-meta-roman-book-09',
};

export const V3CardTitle = styled(Typo.HTMLText).attrs(({ size = '3_COLUMNS' }) => ({
  exClass: `${checkValue(fontClass?.[size]) ? fontClass?.[size] : fontClass['3_COLUMNS']}`,
  tag: 'h2',
}))<{
  color?: string;
  iconColor?: string;
  size?: `3_COLUMNS` | `4_COLUMNS` | `6_COLUMNS` | `FULL_WIDTH`;
  align: 'left' | 'center' | 'right';
}>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    iconColor,
    align = 'left',
    size = '3_COLUMNS',
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${checkValue(color) ? color : token?.v3_card_title_color};
      text-align: ${align};
      
      // commented due to mismatch with live BUSA
      // For max 2 lines of text, according to the functional design
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // display: -webkit-box;
      // overflow: hidden;
      // For max 2 lines of text, according to the functional design
      
      ${
        size.includes('BREAKER_COLLAGE_CARD') &&
        css`
          position: relative;
          padding-left: 16px;
          margin-left: 4px;
          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 8px;
            transform: translateY(-50%);
            width: 8px;
            height: 8px;
            background-color: ${iconColor ? iconColor : token?.caption_icon_color};
            border-radius: 50%;
          }
        `
      };
      }
      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        ${
          size.includes('OVERLAY')
            ? css`
                font-size: 20px !important;
              `
            : ``
        }
      }
    `;
  }}
`;

export const V3CardTitleLeeCounty = styled(Typo.HTMLText).attrs(({ size = '3_COLUMNS' }) => ({
  exClass: `${checkValue(fontClass?.[size]) ? fontClass?.[size] : fontClass['3_COLUMNS']}`,
  tag: 'h6',
}))<{
  color?: string;
  iconColor?: string;
  size?: `3_COLUMNS` | `4_COLUMNS` | `6_COLUMNS` | `FULL_WIDTH`;
  align: 'left' | 'center' | 'right';
}>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    iconColor,
    align = 'left',
    size = '3_COLUMNS',
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${checkValue(color) ? color : token?.v3_card_title_color};
      text-align: ${align};
      
      // commented due to mismatch with live BUSA
      // For max 2 lines of text, according to the functional design
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // display: -webkit-box;
      // overflow: hidden;
      // For max 2 lines of text, according to the functional design
      
      ${
        size.includes('BREAKER_COLLAGE_CARD') &&
        css`
          position: relative;
          padding-left: 16px;
          margin-left: 4px;
        `
      };
      }
      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        ${
          size.includes('OVERLAY')
            ? css`
                font-size: 20px !important;
              `
            : ``
        }
      }
    `;
  }}
`;

export const V3CardLocationTitle = styled(Typo.HTMLText).attrs({
  tag: 'h2',
})<{ color?: string; align: 'left' | 'center' | 'right' }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    align = 'left',
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${checkValue(color) ? color : token?.v3_card_title_color};
      text-align: ${align};
    `;
  }}
`;

export const V3CardPagination = styled(Typo.HTMLText).attrs({
  tag: 'p',
  exClass: 'cpds-meta-roman-medium-book-09',
})<{ color?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    variation,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      text-align: left;
      color: ${checkValue(color) ? color : token?.v3_card_pagination_color};
      ${variation === 'LOCATION' &&
      css`
        margin-bottom: 9px;
      `}
    `;
  }}
`;

export const V3CardDescription = styled(Typo.HTMLText).attrs({
  tag: 'p',
  exClass: 'cpds-meta-roman-book-09',
})<{ color?: string; hideOnMobile?: boolean; marginTop?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    hideOnMobile = false,
    marginTop,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      text-align: left;
      line-height: 10px;
      margin-top: ${checkValue(marginTop) ? marginTop : token?.spacing?.space_4};
      font-weight: 400 !important;
      color: ${checkValue(color) ? color : token?.v3_card_title_color};

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        ${hideOnMobile
          ? css`
              display: none;
            `
          : ``}
      }
    `;
  }}
`;

export const V3CardDescriptionNormal = styled(Typo.HTMLText).attrs({
  tag: 'p',
  exClass: 'cpds-body-roman-book-08',
})<{ color?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      text-align: left;
      color: ${checkValue(color) ? color : token?.v3_card_title_color};
    `;
  }}
`;

export const V3CardIconLabelTextMedium = styled(Typo.HTMLText).attrs({
  tag: 'p',
  exClass: 'cpds-meta-roman-medium-book-10',
})`
  text-align: left;
  line-height: 10px;
`;

export const V3CardIconLabelTextNormal = styled(Typo.HTMLText).attrs({
  tag: 'p',
  exClass: 'cpds-meta-roman-medium-book-10',
})`
  text-align: left;
  line-height: 10px;
  font-weight: 400 !important;
`;

export const V3CardIconLabelTextMeta = styled(Typo.HTMLText).attrs({
  tag: 'p',
  exClass: 'cpds-meta-roman-book-09',
})`
  text-align: left;
`;

export const V3CardIconLabelRow = styled.div<{ color?: string; gap?: string; iconGap?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    gap,
    iconGap,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      align-items: center;
      gap: ${checkValue(gap) ? gap : token?.spacing?.space_6};
      ${V3CardIconLabelTextMedium},
      ${V3CardIconLabelTextNormal},
      ${V3CardIconLabelTextMeta} {
        color: ${checkValue(color) ? color : token?.v3_card_location_color};
      }
      .product-card-calendar-icon {
        width: 13px;
        height: 13px;
      }
      svg {
        width: 10px;
        height: 14px;
        margin-right: ${checkValue(iconGap) ? iconGap : 0};
        path {
          fill: ${checkValue(color) ? color : token?.v3_card_location_icon_color};
        }
      }
    `;
  }}
`;

export const V3CardCtaContainer = styled.div<{
  ctaColor?: string;
  align?: 'flex-start' | 'flex-end' | 'center';
  flexDirection?: 'column' | 'row';
}>`
  ${({
    theme: {
      styles: { cpds },
    },
    ctaColor,
    align = 'flex-start',
    flexDirection = 'column',
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      flex-direction: ${flexDirection};
      justify-content: center;
      align-items: ${checkValue(align) ? align : 'flex-start'};
      .v3-article-card-button,
      .v3-destination-card-button,
      .v3-article-horizontal-card-button {
        display: flex;
        align-items: baseline;
        padding: 0;
        font-size: 12px;
        font-weight: 500;
        gap: 4px;
        color: ${checkValue(ctaColor) ? ctaColor : token?.v3_card_cta_color};
        svg {
          width: 8px;
          height: 7px;
          path {
            fill: ${checkValue(ctaColor) ? ctaColor : token?.v3_card_cta_color};
          }
        }
        &:hover {
          color: ${checkValue(ctaColor) ? ctaColor : token?.v3_card_cta_color};
        }
        span {
          display: flex;
          align-items: center;
        }
      }
      .v3-article-horizontal-card-button,
      .v3-destination-card-button {
        gap: 8px;
        svg {
          width: 5px;
          height: 8px;
        }
      }
      .v3-article-horizontal-card-button,
      .v3-article-card-button,
      .v3-destination-card-button {
        height: fit-content;
      }
      .v3-promotion-terms-button {
        font-weight: 300 !important;
      }
      .v3-promotion-horizontal-card-button {
        text-align: left;
        svg {
          width: 5px;
          height: 8px;
        }
      }
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const V3CardCtaRowContainer = styled.div<{ color?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 6px;
      margin-top: 13px;
      > svg > path {
        fill: ${checkValue(color) ? color : token?.v3_card_location_icon_color};
      }
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const V3CardCtaRowLink = styled(Cpds.Button)`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      gap: 6px;
      padding: 0;
      color: ${checkValue(color) ? color : token?.v3_card_cta_color};
      svg {
        path {
          fill: ${checkValue(color) ? color : token?.v3_card_cta_color};
        }
      }
      &:hover {
        color: ${checkValue(color) ? color : token?.v3_card_cta_color};
      }
      span {
        display: flex;
        align-items: center;
      }
      ${(props) => props?.styleOverrides}
    `;
  }}
`;
